import api from "@/api";
import converters from "@/converters";
import type { DepartmentFragment } from "@/graphql";
import isDataReady from "@/helpers/requests/isDataReady";
import type { LoadingType } from "@/types";
import { useAuthStore } from "@/stores/authStore";
import { computed, ref } from "vue";

const departments = ref<DepartmentFragment[]>([]);
const status = ref<LoadingType>("none");

export function useDepartments() {
  const authStore = useAuthStore();
  const init = async () => {
    if (status.value === "loaded") {
      return;
    }

    status.value = "loading";
    const data = await api.departments.getDepartments();
    departments.value = data.institutions?.getMyInstitution.departments || [];
    status.value = "loaded";
  };

  init();

  const departmentList = computed(() => {
    return departments.value
      .map((item) => {
        return converters.departments.toMultiSelectItem(item);
      })
      .toSorted((a, b) =>
        a.title.localeCompare(b.title, authStore.institutionLocale),
      );
  });

  const departmentOptions = computed(() => {
    return departments.value
      .map((item) => {
        return converters.departments.toOption(item);
      })
      .toSorted((a, b) =>
        a.title.localeCompare(b.title, authStore.institutionLocale),
      );
  });

  const loading = computed(() => {
    return status.value === "loading";
  });

  const isReady = () => isDataReady(status);

  return {
    departments,
    departmentList,
    departmentOptions,
    loading,
    isReady,
  };
}
